import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionTitle } from '../ui/SectionTitle';
const features = ['Rider-Waite', 'Tarot de Marsella', 'Interpretación Profesional', 'Tarot Evolutivo', 'Material práctico', 'Formación completa'];
export function WhyDifferent() {
  return <section className="py-20 relative z-10" data-id="element-254">
      <div className="container mx-auto px-4" data-id="element-255">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-4 flex justify-center" data-id="element-256">
          <SectionTitle data-id="element-257">¿Por qué es diferente?</SectionTitle>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-258">
          {features.map((feature, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-mystic-800/80 border border-gold/20 p-6 rounded-xl flex items-center gap-4" data-id="element-259">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-260">
                <Check size={16} className="text-gold" data-id="element-261" />
              </div>
              <span className="font-medium text-white/90" data-id="element-262">{feature}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}